export default "__VITE_ASSET__CWdjtJt6__"